import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';

export interface AiSuggestion {
    message: string;
}

export interface AiSuggestionResponse {
    data: AiSuggestion;
}

export interface AiSuggestionsResponse {
    data: AiSuggestion[];
}

export interface QuickBlastParams {
    details: string;
}

export interface MessageHubSuggestionsParams {
    contact_id: number;
}

class AiClient extends BaseClient {
    quickBlastSuggestions(teamId: number, params: QuickBlastParams): AxiosPromise<AiSuggestionsResponse> {
        const url = `/api/v3/teams/${teamId}/ai/quick-blast`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    quickBlastFollowUp(teamId: number, campaignId: number): AxiosPromise<AiSuggestionsResponse> {
        const url = `/api/v3/teams/${teamId}/ai/quick-blast/${campaignId}/follow-up`;
        return this.makeCoreApiRequest(url, 'post');
    }

    messageHubSuggestions(teamId: number, params: MessageHubSuggestionsParams): AxiosPromise<AiSuggestionResponse> {
        const url = `/api/v3/teams/${teamId}/ai/message`;
        return this.makeCoreApiRequest(url, 'post', params);
    }
}

export default new AiClient();
